export class FileToUpload {
  fileName: string = "";
  fileSize: number = 0;
  fileAsBase64: string = "";
  packageNo: number = 0;
  loginID: number = 0;
  publisherID: number = 0;
  fileNumber: number = 0;
  processType: string = "";
  entryType: string = "";
  vendorConfigID: number = 0;
  id: number = 0;
  instruction: string = "";
  dueDate: string = "";
  ArticleID: number = 0;
  ProcessId: number = 0;
  Pages: number = 0;
  nextActivityID: number = 0;
  correctionTypeXmlPdf: string = "";
  epubDate: string = "";
  imageCount: number = 1;
}
